import { render, staticRenderFns } from "./Imageslider.vue?vue&type=template&id=021be94d&scoped=true&"
import script from "./Imageslider.vue?vue&type=script&lang=js&"
export * from "./Imageslider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021be94d",
  null
  
)

export default component.exports